import { AgreementStatus } from '../../../types/Agreements.types';

const agreementStatusMap: Record<AgreementStatus, string> = {
  enabled: 'Active',
  disabled: 'Inactive',
};

export function mapAgreementStatus(status: string): string {
  if (status in agreementStatusMap) {
    return agreementStatusMap[status as AgreementStatus];
  }
  return status;
}
